var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container is-centered sign-in"},[_c('SignInForm',{attrs:{"mode":_vm.routerName,"header-title":"Password Reset","button-title":"Submit","show-errors":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }